/**
 * "Has the parent changed anything since the editor opened?" (2026-10-17, Jens: the ✕ asks to save
 * only when there is something to save). Compares a snapshot of the form, so changing something and
 * changing it back counts as unchanged. Empty values (undefined, null, '') count as the same, and
 * the order of keys does not matter.
 */
export function editorStateKey(value: unknown): string {
  return JSON.stringify(normalise(value)) ?? '';
}

function normalise(value: unknown): unknown {
  if (value === undefined || value === null || value === '') return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value.toISOString();
  if (Array.isArray(value)) return value.map(normalise);
  if (typeof value === 'object') {
    const out: Record<string, unknown> = {};
    for (const k of Object.keys(value as object).sort()) {
      const v = normalise((value as Record<string, unknown>)[k]);
      if (v !== null) out[k] = v;
    }
    return out;
  }
  return value;
}

export function hasEditorChanges(initial: unknown, current: unknown): boolean {
  return editorStateKey(initial) !== editorStateKey(current);
}
